module.exports = __webpack_public_path__ + "static/assetsIcon-582e1e06191eb0c353a38e104427c9a4.png";